import { render, staticRenderFns } from "./helpWord.vue?vue&type=template&id=2291e63c&scoped=true&"
import script from "./helpWord.vue?vue&type=script&lang=js&"
export * from "./helpWord.vue?vue&type=script&lang=js&"
import style0 from "./helpWord.vue?vue&type=style&index=0&id=2291e63c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2291e63c",
  null
  
)

export default component.exports